










import { PaymentPlanScheduleTypeEnum } from '@/models';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'PaymentPlanSchedulePaymentTypePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: Number as PropType<PaymentPlanScheduleTypeEnum>
  },

  data() {
    return {
      lazyValue: this.value
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      getPaymentPlanScheduleVisuals: 'paymentPlan/getPaymentPlanScheduleVisuals'
    }),

    scheduleTypes(): PaymentPlanScheduleTypeEnum[] {
      return this.getPaymentPlanScheduleVisuals;
    },

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    }
  }
});
